(() => {
  const API_URL = 'https://api.mangorace.com/product-reviews';

  function addText(parent, tag, className, text) {
    const element = document.createElement(tag);
    if (className) element.className = className;
    element.textContent = text;
    parent.appendChild(element);
    return element;
  }

  function starLabel(rating) {
    const rounded = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
    return `${'★'.repeat(rounded)}${'☆'.repeat(5 - rounded)}`;
  }

  function formatDate(value) {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return new Intl.DateTimeFormat(document.documentElement.lang || 'en', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    }).format(date);
  }

  function renderSummary(target, summary) {
    target.replaceChildren();
    const count = Number(summary?.count || 0);
    if (!count) {
      const empty = document.createElement('div');
      empty.className = 'product-reviews__empty';
      addText(empty, 'strong', '', 'No verified buyer reviews yet');
      addText(empty, 'p', '', 'After a purchase, customers can submit a review from their order details.');
      target.appendChild(empty);
      return;
    }

    const average = Number(summary.average || 0);
    const rating = document.createElement('div');
    rating.className = 'product-reviews__rating';
    addText(rating, 'strong', '', average.toFixed(1));
    const detail = document.createElement('span');
    addText(detail, 'span', 'product-reviews__stars', starLabel(average));
    addText(detail, 'small', '', `${count} verified review${count === 1 ? '' : 's'}`);
    rating.appendChild(detail);
    target.appendChild(rating);
  }

  function renderReview(review) {
    const card = document.createElement('article');
    card.className = 'product-review-card';

    const header = document.createElement('header');
    const identity = document.createElement('div');
    addText(identity, 'strong', 'product-review-card__name', review.customerDisplayName || 'MangoRace customer');
    const meta = document.createElement('div');
    meta.className = 'product-review-card__meta';
    if (review.verifiedPurchase) addText(meta, 'span', 'product-review-card__verified', 'Verified purchase');
    const date = formatDate(review.createdAt);
    if (date) addText(meta, 'span', '', date);
    identity.appendChild(meta);
    header.appendChild(identity);
    const stars = addText(header, 'span', 'product-reviews__stars', starLabel(review.rating));
    stars.setAttribute('aria-label', `${review.rating} out of 5 stars`);
    card.appendChild(header);

    if (review.title) addText(card, 'h3', '', review.title);
    addText(card, 'p', 'product-review-card__body', review.body);

    if (Array.isArray(review.media) && review.media.length) {
      const media = document.createElement('div');
      media.className = 'product-review-card__media';
      review.media.forEach((item, index) => {
        const image = document.createElement('img');
        image.src = item.url;
        image.alt = `Customer product photo ${index + 1}`;
        image.loading = 'lazy';
        image.decoding = 'async';
        media.appendChild(image);
      });
      card.appendChild(media);
    }

    if (review.merchantReply) {
      const reply = document.createElement('div');
      reply.className = 'product-review-card__reply';
      addText(reply, 'strong', '', 'Reply from MangoRace');
      addText(reply, 'p', '', review.merchantReply);
      card.appendChild(reply);
    }
    return card;
  }

  async function loadReviews(section) {
    const summaryTarget = section.querySelector('[data-review-summary]');
    const listTarget = section.querySelector('[data-review-list]');
    const productId = section.dataset.productId;
    if (!summaryTarget || !listTarget || !productId) return;

    try {
      const response = await fetch(`${API_URL}?productId=${encodeURIComponent(productId)}&limit=20`, {
        headers: {Accept: 'application/json'}
      });
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.message || 'Unable to load reviews.');
      renderSummary(summaryTarget, payload.summary);
      listTarget.replaceChildren(...(payload.reviews || []).map(renderReview));
    } catch (_error) {
      summaryTarget.replaceChildren();
      const message = addText(summaryTarget, 'p', 'product-reviews__error', 'Verified reviews are temporarily unavailable. Please try again later.');
      message.setAttribute('role', 'status');
      listTarget.replaceChildren();
    }
  }

  document.querySelectorAll('[data-product-reviews]').forEach(loadReviews);
})();
